import utils from '@/mixins/utils.js'

export const dataFields = {
  Nome: 'no_cidadao',
  'Data de nascimento': {
    callback: (item) => {
      if (!item.dt_nascimento) return '-'
      const idade = item.idade != null ? Number(item.idade) : 0
      return `${utils.methods.formatDate(item.dt_nascimento)} (${idade} ${
        idade > 1 ? 'anos' : 'ano'
      })`
    },
  },
  Mãe: 'no_mae',
  Admissão: {
    callback: (item) => {
      return item.dt_admissao ? utils.methods.formatDate(item.dt_admissao) : '-'
    },
  },
  Conclusão: {
    callback: (item) => {
      return item.dt_conclusao ? utils.methods.formatDate(item.dt_conclusao) : '-'
    },
  },
  CPF: 'nu_cpf',
  CNS: 'nu_cns',
  Endereço: {
    callback: (item) => item.endereco || item.ds_endereco || '-',
  },
  Microárea: 'micro_area',
  'Cadastrado por': 'no_profissional',
}

export const optionsFilterVulnerabilidade = [
  {
    label: 'Todos',
    value: null,
    key: 'todos',
    valuesToSearch: [],
  },
  {
    label: 'PBF ou BPC',
    value: 'vulnerabilidade',
    key: 'pbf-ou-bpc',
    valuesToSearch: ['PBF', 'BPC'],
  },
  {
    label: 'Pessoa idosa',
    value: 'vulnerabilidade',
    key: 'pessoa-idosa',
    valuesToSearch: ['60 anos ou mais'],
  },
  {
    label: 'Crianças',
    value: 'vulnerabilidade',
    key: 'criancas',
    valuesToSearch: ['Ate 5 anos'],
  },
]
